import { memo, useState } from "react";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "./Highlight/Highlight";
import TabTitleContentViewerFragment from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/viewer-fragments/TabTitleContentViewerFragment/TabTitleContentViewerFragment";
import type { TabTitleContentViewerFragmentConfigProps } from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/viewer-fragments/TabTitleContentViewerFragment/TabTitleContentViewerFragment";
import type { ViewerFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/viewer-fragments/ViewerFragment";
import { LOADING } from "@coworker/apprestructured/src/task-management/loading";
import Actions from "./Actions/Actions";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import {
  FixaOption,
  FixaSelect,
} from "@coworker/apprestructured/src/shared/wrappers/FixaSelect/FixaSelect";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";

const CURRENCIES = ["EUR", "SEK", "USD", "JPY"];

function TabTitleContentViewerFragmentDemo() {
  const [showAmount, setShowAmount] = useState(true);
  const [currency, setCurrency] = useState("EUR");
  const mockTask = {
    id: "12345",
    state: "completed",
    details: showAmount
      ? {
          passed_sales: 150,
          lost_sales: 25,
          currency,
        }
      : {},
  };

  const configProps: TabTitleContentViewerFragmentConfigProps = {
    tabs: [
      {
        title: "passedSalesString",
        description: "passedSalesDescriptionString",
        amount: "details.passed_sales",
        currency: "details.currency",
      },
      {
        title: "lostSalesString",
        description: "lostSalesDescriptionString",
        amount: "details.lost_sales",
        currency: "details.currency",
      },
    ],
  };

  const commonProps: ViewerFragmentCommonProps = {
    blockInput: false,
    task: mockTask,
    onTaskChange: () => {},
    showValidation: false,
    taskType: LOADING,
  };

  return (
    <Demo>
      <Name>TabTitleContentViewerFragment</Name>

      <Highlight>
        <div style={{ padding: "16px", background: "var(--white)" }}>
          <TabTitleContentViewerFragment
            configProps={configProps}
            commonProps={commonProps}
          />
        </div>
      </Highlight>

      <Actions>
        <FixaCheckbox
          label="show amount"
          value="switchdemo-disabled"
          id="switchdemo-disableAmount"
          checked={showAmount}
          onChange={() => setShowAmount((prev) => !prev)}
        />
        <FixaSelect
          id="switchdemo-currency"
          value={currency}
          onChange={(e) => setCurrency(e.target.value as string)}
          label="currency"
          required
        >
          {CURRENCIES.map((currency) => (
            <FixaOption key={currency} name={currency} value={currency} />
          ))}
        </FixaSelect>
      </Actions>
    </Demo>
  );
}

export default memo(TabTitleContentViewerFragmentDemo);
